// extracted by mini-css-extract-plugin
export var dividerContainer = "_82-0";
export var line = "_82-1";